// extracted by mini-css-extract-plugin
export default {"container":"MycawFollowUpTypeformLink_container__mRONl"};